import * as qs from 'qs';
import { axiosTemplate } from '../../axiosTemplate';
export const movReportScheduler = {
    endpoints: {
        test: `https://p0p2jra0jh.execute-api.us-east-1.amazonaws.com/test/v0/rest/report-schedule`,
        acceptance: `https://krb2vpooae.execute-api.us-east-1.amazonaws.com/acceptance/v0/rest/report-schedule`,
        prod: `https://ngcc5msrz8.execute-api.us-east-1.amazonaws.com/prod/v0/rest/report-schedule`,
    },
    http: {
        create: ({ data, stage, token, cancelToken, headers }) => {
            return axiosTemplate(token, cancelToken, headers).post(`${movReportScheduler.endpoints[stage]}/`, data);
        },
        getAll: ({ stage, token, cancelToken, reportIds, headers }) => {
            const queryString = reportIds ? '?' + qs.stringify({ reportIds }, { arrayFormat: 'repeat' }) : '';
            return axiosTemplate(token, cancelToken, headers).get(`${movReportScheduler.endpoints[stage]}${queryString}`);
        },
        get: ({ stage, token, cancelToken, reportScheduleId, headers }) => {
            return axiosTemplate(token, cancelToken, headers).get(`${movReportScheduler.endpoints[stage]}/${reportScheduleId}`);
        },
        remove: ({ reportScheduleId, token, stage, cancelToken, headers }) => {
            return axiosTemplate(token, cancelToken, headers).delete(`${movReportScheduler.endpoints[stage]}/${reportScheduleId}`);
        },
        update: ({ data, token, reportScheduleId, stage, cancelToken, headers }) => {
            return axiosTemplate(token, cancelToken, headers).put(`${movReportScheduler.endpoints[stage]}/${reportScheduleId}`, data);
        },
        previewReportFilenames: ({ data, stage, token, cancelToken, headers }) => {
            return axiosTemplate(token, cancelToken, headers).post(`${movReportScheduler.endpoints[stage]}/preview-report-filename`, data);
        },
    },
};
